module.exports = __webpack_public_path__ + "img/Taiwan-hover.b8bdd12d.jpg";